import moment from 'moment';
import { DATE_FORMAT } from '../constants/orders/date-format';

export const decodeDate = date => (date ? moment(date, DATE_FORMAT).format('YYYY-MM-DD') : '');

export const formatDate = date => (date ? moment(date).format(DATE_FORMAT) : '');
